import { render, staticRenderFns } from "./FormGroupAddress.vue?vue&type=template&id=71b7cac4"
import script from "./FormGroupAddress.vue?vue&type=script&lang=js"
export * from "./FormGroupAddress.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports